import dynamic from 'next/dynamic'

export const DynamicCouponModal = dynamic(() => import('.').then((mod) => mod.CouponModal), {
  ssr: false,
})
